export interface SkeletonProps {
  /** How many shimmer lines to render (a stand-in for lines of text). */
  readonly lines?: number;
  readonly className?: string;
  /** Accessible label announced while content loads. */
  readonly 'aria-label'?: string;
}

/**
 * A token-styled loading placeholder: one or more shimmer lines shown in place of
 * content that is still loading. It carries a live `status` role so assistive tech
 * announces the loading state, and honours reduced-motion by dropping the shimmer.
 */
export function Skeleton({
  lines = 1,
  className,
  'aria-label': ariaLabel = 'Loading',
}: SkeletonProps) {
  const count = Math.max(1, lines);
  const classes = ['nuff-skeleton', className].filter(Boolean).join(' ');
  return (
    <div className={classes} role="status" aria-busy="true" aria-label={ariaLabel}>
      {Array.from({ length: count }, (_, index) => (
        <span key={index} className="nuff-skeleton__line" aria-hidden="true" />
      ))}
    </div>
  );
}
